jQuery(document).ready(function($) {
  var controller = new ScrollMagic.Controller();
  var scenesArray = [];

  if($('.wf-sustainable-block').length) {
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: '.wf-sustainable-block'
    })
    .setClassToggle('.wf-sustainable-block', 'show')
    .reverse(false)
    // .addIndicators()
    .addTo(controller)
    );
  }

  // if($('.wf-sustainable-block .tp-separator').length) {
  //   scenesArray.push(new ScrollMagic.Scene({
  //     triggerElement: '.tp-separator'
  //   })
  //   .setClassToggle('.tp-separator', 'show')
  //   .reverse(false)
  //   // .addIndicators()
  //   .addTo(controller)
  //   );
  // }

  // if($('.wf-sustainable-block .tp-container').length) {
  //   $('.wf-sustainable-block .tp-container').each(function() {
  //     var columnID = 'tp' + (Math.floor(Math.random() * 26) + Date.now());
  //     $(this).attr('id', columnID);
  //   });
  //
  //   $('.wf-sustainable-block .tp-container').each(function() {
  //     scenesArray.push(new ScrollMagic.Scene({
  //       triggerElement: '#'+$(this).attr('id')
  //     })
  //     .setClassToggle('#'+$(this).attr('id'), 'show')
  //     .reverse(false)
  //     // .addIndicators()
  //     .addTo(controller)
  //     );
  //   });
  // }
});
